import React, { useState, useEffect } from "react";
import {
  FormControlLabel,
  IconButton,
  Tooltip,
  ClickAwayListener,
} from "@material-ui/core";
import moment from "moment";
import {
  ContentListCard,
  Name,
  OtherInfo,
  ContainInfo,
  Id,
  CreateUser,
  ContainButtons,
  ButtonLinkActive,
  ButtonViewPreview,
  RatingContainer,
  ContentUser,
  UserText,
  ContentInternal,
  InternalReviewText,
  DateText,
  ContentComments,
  Comments,
  IdText,
  ContentHr,
  Hr,
  ToolName,
  ContainNameTools,
  TotalReviewLink,
  TotalLinearLink,
  LinearContainer,
  ContentUserInfo,
  BoxColor,
  Country,
  Start,
  StartButton
} from "./ListCardViewControl.styled";
import InfoIcon from "@material-ui/icons/Info";
import MenuManageSurveys from "../MenuManageSurveys/MenuManageSurveys";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import MenuManageCategories from "../MenuManageCategories/MenuManageCategories";
import MenuManageEvents from "../MenuManageEvents/MenuManageEvents";
import MenuManageGuests from "../MenuManageGuests/MenuManageGuests";
import DownloadLink from "../DownloadLink/DownloadLink";
import MenuManageEmailTemplate from "../MenuManageEmailTemplate/MenuManageEmailTemplate";
import ErrorIcon from "@mui/icons-material/Error";
import LogoutIcon from "@mui/icons-material/Logout";
import TextsmsIcon from "@mui/icons-material/Textsms";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import { Box, LinearProgress } from "@mui/material";
import { AntSwitch } from "../../helpers/antSwitch";
import { ReactComponent as MenuActionsIcon } from "../../assets/svg/menu-actions-icon.svg";
import ReactCountryFlag from "react-country-flag";
import { withStyles } from "@material-ui/core/styles";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import PropTypes from "prop-types";
import { theme as themeConfig } from "../../themes/themes";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: themeConfig.neutral.gray[2500],
    color: "white",
    padding: "1em 1em 1em 0",
    border: `1px solid ${themeConfig.border.light}`,
  },
}))(Tooltip);

const ListCardViewControl = ({
  identity,
  item,
  isApprovalsRequested,
  isAgent,
  isHistory,
  isRecurrent,
  toggleChecked,
  classes,
  handleClickActions,
  anchorSelected,
  anchorEl,
  handleCloseActions,
  handleEditSurvey,
  handleEditEvent,
  handleEditEmail,
  handlePreview,
  handleSeeDetails,
  handleDownload,
  handleGuests,
  setAnchorEl,
  setAnchorSelected,
  setOpenDeleteModal,
  setOpenCloneSurveyModal,
  setOnlyAssigned,
  setOpenActiveSurveyModal,
  encriptParametersSurvey,
  setupdateData,
  triggerValue,
  setFormTrigger,
  setOpenResumeAnswer,
  handleReview,
  style = {},
  handleCreateSurveyFromTemplate,
  statistics = {},
  handleRatingDownload,
  kindOfList,
  itsSurvey,
}) => {
  // console.log("******", item, identity)
  const [userComplete] = useState(getStateLoginComplete());
  const [detail, setDetail] = useState({});
  const [openDescription, setOpenDescription] = useState(false);
  const [labelDescription, setLabelDescription] = useState("");

  useEffect(() => {
    if (detail.description)
      setLabelDescription(`Description: ${detail.description}`);
  }, [detail.description]);


  console.log(identity)


  useEffect(() => {
    switch (identity) {
      case "survey-homelist":
        return handleSetDataSurveyList();
      case "survey-list":
        return handleSetDataSurveyList();
      case "survey-list-manage":
        return handleSetDataSurveyList();
      case "email-template-list":
        return setDetail({
          id: item.idEmailTemplate,
          name: item.name,
          description: item.description,
          createDate: moment(item.createDate, "YYYY-MM-DD hh:mm a").format(
            "YYYY-MM-DD"
          ),
          itemState: item.recordState,
          country: item.allCountries ? "All Countries" : item.countryName,
        });
      case "survey-categories":
        return setDetail({
          id: item.idCategorySurvey,
          name: item.categoryDescription,
          itemState: item.recordState,
          createUser: item.createUser,
          createDate: moment(item.createDate, "YYYY-MM-DD hh:mm a").format(
            "YYYY-MM-DD"
          ),
        });
      case "theme-categories":
        return setDetail({
          id: item.idCounsellingTheme,
          name: item.themeName,
          itemState: item.recordState,
          createUser: item.createUser,
          createDate: moment(item.createDate, "YYYY-MM-DD hh:mm a").format(
            "YYYY-MM-DD"
          ),
        });
      case "question-categories":
        return setDetail({
          id: item.idCategoryQuestion,
          name: item.description,
          itemState: item.recordState,
          createUser: item.createUser,
          createDate: moment(item.createDate, "YYYY-MM-DD hh:mm a").format(
            "YYYY-MM-DD"
          ),
        });
      case "event-list":
        return setDetail({
          id: item.idEvent,
          name: item.eventName,
          type: item.eventType,
          categoryName: item.categoryName,
          itemState: item.eventState,
          eventDate: item.startDateFormatted,
          duration: item.duration,
          createUser: item.createUser,
          confirmed: item.confirmed,
          guests: item.guests,
          averageRating: item.averageRating,
          totalReviews: item.totalReviews,
          feedbacks: item.feedbacks,
          description: item.description,
        });
      case "event-list-coach":
        return setDetail({
          id: item.idEvent,
          name: item.eventName,
          //  type: item.eventType,
          categoryName: item.categoryName,
          itemState: item.eventState,
          eventDate: item.startDateFormatted,
          duration: item.duration,
          createUser: item.createUser,
          confirmed: item.confirmed,
          guests: item.guests,
          averageRating: item.averageRating,
          totalReviews: item.totalReviews,
          feedbacks: item.feedbacks,
          description: item.description,
          startTime: item.startTime,
          theme: item.themeLabel,
        });
      case "private-guests":
        return setDetail({
          id: item.id,
          name: item.firstName + " " + item.lastName,
          email: item.email,
          countryId: item.country,
          cityName: item.city,
          registrationDate: moment(item.startDate, "YYYY-MM-DD hh:mm a").format(
            "YYYY-MM-DD hh:mm a"
          ),
          itemState: item.status,
        });
      case "public-guests":
        return setDetail({
          id: item.id,
          name: item.firstName + " " + item.lastName,
          email: item.email,
          countryId: item.country,
          cityName: item.city,
          registrationDate: moment(item.startDate, "YYYY-MM-DD hh:mm a").format(
            "YYYY-MM-DD"
          ),
        });
      case "event-categories":
        return setDetail({
          id: item.idCategory,
          name: item.categoryName,
          codeColor: item.codeColor,
          itemState: item.recordState,
          createUser: item.createUser,
          createDate: moment(item.createDate, "YYYY-MM-DD hh:mm a").format(
            "YYYY-MM-DD"
          ),
        });
      case "coaches-list":
        return setDetail({
          id: item.idCoach,
          name: item.cFirstName + " " + item.cLastName,
          countryName: item.cCountryName,
          cityName: item.cCityName,
          agentsAssigned: item.agentsAssigned,
          itemState: item.coachState,
        });
      case "lob-list":
        return setDetail({
          id: item.lobid,
          name: item.name,
          description: item.description,
          itemState: item.statusId ? 2 : 3,
          countryName: item.countryName,
          createDate: item.createDate,
          createUser: item.createUser,
          usersInLob: item.usersInLob,
        });
      case "site-list":
        return setDetail({
          id: item.locationId,
          name: item.country,
          countryName: item.country,
          itemState: item.statusId ? 2 : 3,
          cityName: item.city,
          site: item.city,
          createDate: item.createDate,
          createUser: item.createUser,
        });
      case "detail-report-list":
        return setDetail({
          id: item.idSurvey,
          name: item.surveyName,
          description: item.surveyDescription,
          assignedUsers: item.assignedUsers,
          answered: item.answeredSurveys,
          remaining: item.remainingSurveys,
          activationDate: moment(
            item.activateSurveyDate,
            "YYYY-MM-DD hh:mm a"
          ).format("YYYY-MM-DD"),
          createUser: item.createUser,
          countryName: item.country,
          cityName: item.city,
          itemState: item.idSurveyState,
        });
      case "my-insights":
        return handleSetUpCasesAndInsightsDetail();
      case "my-cases":
        return handleSetUpCasesAndInsightsDetail();
      default:
        break;
    }
  }, [identity, isAgent, isHistory, isRecurrent, item, setOpenActiveSurveyModal, toggleChecked]);

  let handleSetUpCasesAndInsightsDetail = () => {
    return setDetail({
      caseId: item.idCase,
      name: item.idFormNavigation.name,
      submissionDate: moment(item.submissionDate).format("YYYY/MM/DD"),
      beingManageBy: item.handlerUserInfo?.ccmsuser,
      itemState: item.state,
      totalComments: item.totalComments,
      highPriority: item.highPriority,
      highPriorityReason: item.highPriorityReasons,
      hasAttachment: item.hasAttachment,
    });
  };

  let handleSetDataSurveyList = () => {
    return setDetail({
      id: item.idSurvey,
      name: item.surveyName,
      description: item.surveyDescription,
      itemState: item.idSurveyState,
      createUser: item.createUser,
      activationDate: moment(
        item.activateSurveyDate,
        "YYYY-MM-DD hh:mm a"
      ).format("YYYY-MM-DD"),
    });
  };
  // console.log("*******", detail)

  let handleGreenSwitchSurveyList = (element) => {
    return element?.integrationTpclient &&
      element?.idSurveyState &&
      element?.idSurveyState === 5 ? (
      <></>
    ) : (
      <AntSwitch
        size="small"
        disabled={
          (element?.idSurveyState === 1 && element?.idSurveyState) ||
            (element?.idSurveyState === 7 && element?.idSurveyState) ||
            (element?.idSurveyState === 5 && element?.idSurveyState) ||
            (element?.idSurveyState === 6 && element?.idSurveyState)
            ? true
            : false
        }
        checked={
          (element?.idSurveyState === 1 && element?.idSurveyState) ||
            (element?.idSurveyState === 3 && element?.idSurveyState) ||
            (element?.idSurveyState === 7 && element?.idSurveyState) ||
            (element?.idSurveyState === 5 && element?.idSurveyState) ||
            (element?.idSurveyState === 6 && element?.idSurveyState)
            ? false
            : true
        }
        onChange={() => toggleChecked(element)}
      />
    );
  };

  let handleGreenSwitchRecordState = (element) => {
    return (
      <AntSwitch
        size="small"
        disabled={
          element?.idCategory === 1 && element?.idCategory ? true : false
        }
        checked={
          element?.recordState?.toUpperCase() === "ACTIVE" ? true : false
        }
        onChange={() => toggleChecked(element)}
      />
    );
  };

  let handleGreenSwitchEventState = (element) => {
    return (
      <AntSwitch
        size="small"
        checked={element?.eventState.toUpperCase() === "ACTIVE" ? true : false}
        onChange={() => toggleChecked(element)}
      />
    );
  };

  let handleGreenSwitchCoachesState = (element) => {
    return (
      <AntSwitch
        size="small"
        checked={element?.coachState.toUpperCase() === "ACTIVE" ? true : false}
        onChange={() => toggleChecked(element)}
      />
    );
  };

  let handleGreenSwitchSiteLobState = (element) => {
    return (
      <AntSwitch
        size="small"
        checked={element?.statusId}
        onChange={() => toggleChecked(element)}
      />
    );
  };

  let handleGreenSwitch = (element) => {
    switch (identity) {
      case "survey-list":
        return handleGreenSwitchSurveyList(element);
      case "survey-list-manage":
        return handleGreenSwitchSurveyList(element);
      case "email-template-list":
        return handleGreenSwitchRecordState(element);
      case "survey-categories":
        return handleGreenSwitchRecordState(element);
      case "theme-categories":
        return handleGreenSwitchRecordState(element);
      case "question-categories":
        return handleGreenSwitchRecordState(element);
      case "event-list":
        return handleGreenSwitchEventState(element);
      case "event-list-coach":
        return handleGreenSwitchEventState(element);
      case "event-categories":
        return handleGreenSwitchRecordState(element);
      case "coaches-list":
        return handleGreenSwitchCoachesState(element);
      case "lob-list":
        return handleGreenSwitchSiteLobState(element);
      case "site-list":
        return handleGreenSwitchSiteLobState(element);
      default:
        break;
    }
  };

  return (
    <ContentListCard
      identity={identity}
      itemState={detail?.itemState}
      style={{
        backgroundColor: detail?.highPriority ? themeConfig.status.errorLight : themeConfig.neutral.white,
        ...style,
      }}
      highPriority={detail?.highPriority}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {detail.name &&
          identity !== "event-list" &&
          identity !== "event-list-coach" &&
          identity !== "event-categories" && (
            <Name identity={identity}>{detail.name}</Name>
          )}
        {((identity === "survey-list-manage" || identity === "survey-list") && identity !== "survey-homelist") && (
          <MenuManageSurveys
            item={item}
            anchorSelected={anchorSelected}
            anchorEl={anchorEl}
            handleCloseActions={handleCloseActions}
            handleEditSurvey={handleEditSurvey}
            setAnchorEl={setAnchorEl}
            setAnchorSelected={setAnchorSelected}
            setOpenDeleteModal={setOpenDeleteModal}
            setOpenCloneSurveyModal={setOpenCloneSurveyModal}
            setOnlyAssigned={setOnlyAssigned}
            handlePreview={handlePreview}
            assignedUSers={statistics?.data?.usersAssigned}
            itsSurvey={itsSurvey}
          />
        )}
        {identity === "survey-list-manage" && (
          <Tooltip title="Actions">
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              className={classes.active}
              onClick={(e) => handleClickActions(e, item)}
            >
              <MenuActionsIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>

      {(identity === "event-list" ||
        identity === "event-categories" ||
        identity === "event-list-coach") && (
          <ContainNameTools>
            {detail.name && (
              <Tooltip title={detail.name}>
                <ToolName identity={identity}>{detail.name}</ToolName>
              </Tooltip>
            )}
            <Tooltip title="Actions">
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={(e) => handleClickActions(e, item)}
              >
                <MenuActionsIcon />
              </IconButton>
            </Tooltip>
          </ContainNameTools>
        )}
      {(identity === "my-insights" || identity === "my-cases") && (
        <>
          <ContentUser>
            <UserText>
              {detail.beingManageBy ? detail.beingManageBy : "User not found"}
            </UserText>
            <div
              style={
                detail.beingManageBy
                  ? {}
                  : { justifyContent: "end", display: "flex", width: "20px" }
              }
            >
              <Tooltip title={"High Priority"}>
                <IconButton hidden={detail.highPriority ? false : true}>
                  <ErrorIcon style={{ fontSize: "16px", color: themeConfig.status.error }} />
                </IconButton>
              </Tooltip>
            </div>
            {detail.hasAttachment && (
              <div
                style={
                  detail.beingManageBy
                    ? {}
                    : { justifyContent: "end", display: "flex", width: "10px" }
                }
              >

                <Tooltip title={"Attach File"}>
                  <IconButton>
                    <AttachFileIcon style={{ fontSize: "16px" }} />
                  </IconButton>
                </Tooltip>

              </div>
            )}
            <div
              style={{ width: "1em", height: "1em" }}
              hidden={detail.highPriority ? true : false}
            ></div>
            <Tooltip title="Detail">
              <IconButton onClick={() => handleSeeDetails(item)}>
                <LogoutIcon style={{ fontSize: "16px", color: themeConfig.text.primary }} />
              </IconButton>
            </Tooltip>
          </ContentUser>
          <ContentHr>
            <Hr />
          </ContentHr>
          <ContentInternal>
            <InternalReviewText>Internal Review</InternalReviewText>
            <DateText>{detail.submissionDate}</DateText>
          </ContentInternal>
          <ContentComments>
            <Comments>
              <TextsmsIcon style={{ fontSize: "12px" }} />{" "}
              {detail.totalComments} Comments
            </Comments>
            <IdText>ID: {detail.caseId}</IdText>
          </ContentComments>
        </>
      )}
      {(identity === "event-list" || identity === "event-list-coach") && (
        <RatingContainer>
          <p style={{ fontWeight: "bold" }}>{detail.averageRating}</p>
          <Stack spacing={1}>
            <Rating
              name="half-rating-read"
              value={parseInt(detail.averageRating)}
              precision={0.5}
              size="small"
              readOnly
            />
          </Stack>
          <TotalReviewLink onClick={() => handleRatingDownload(item)}>
            {detail.totalReviews !== 0 ? detail.totalReviews : 0} reviews
          </TotalReviewLink>
        </RatingContainer>
      )}

      {detail.confirmed >= 0 ? (
        <LinearContainer>
          <p style={{ fontWeight: "bold" }}>{detail.confirmed}%</p>
          <Box sx={{ width: "100%", marginInline: "1em" }}>
            <LinearProgress
              color="success"
              variant="determinate"
              value={parseInt(detail.confirmed)}
            />
          </Box>
          <TotalLinearLink onClick={() => handleGuests(item)}>
            Guests
          </TotalLinearLink>
        </LinearContainer>
      ) : (
        ""
      )}

      <ContentUserInfo
        hidden={
          identity !== "event-list" &&
          identity !== "event-categories" &&
          identity !== "event-list-coach"
        }
      >
        <p>{detail.createUser}</p>
        <p>ID:{detail.id}</p>
      </ContentUserInfo>

      <ContainInfo
        hidden={
          identity === "my-insights" ||
          identity === "my-cases" ||
          identity === "event-list" ||
          identity === "event-categories" ||
          identity === "event-list-coach"
        }
        identity={identity}
      >
        <div className="info-container">
          {detail?.createUser && <CreateUser>{detail.createUser}</CreateUser>}
          {detail?.country && identity === "email-template-list" && (
            <Country>{detail.country}</Country>
          )}
          {identity !== "email-template-list" && (
            <div className="d-flex justify-content-between mr-3">
              <Id style={{ marginBottom: "0" }}>ID:{detail.id}</Id>
            </div>
          )}
        </div>
      </ContainInfo>
      {detail.email && (
        <OtherInfo>
          <b>Email:</b> {detail.email}
        </OtherInfo>
      )}
      {detail.countryId && (
        <OtherInfo className="d-flex">
          <b>Country:</b>&nbsp;
          <ReactCountryFlag
            svg
            countryCode={detail.countryId}
            style={{
              width: "1.5rem",
              height: "1.5rem",
              borderRadius: "8px",
            }}
          />
        </OtherInfo>
      )}
      {detail.assignedUsers >= 0 && (
        <OtherInfo>
          <b>Assigned users:</b> <span>{detail.assignedUsers}</span>
        </OtherInfo>
      )}
      {detail.answered >= 0 && (
        <OtherInfo className="mb-0">
          <b>Have answered:</b> <span>{`${detail.answered}`}</span>
        </OtherInfo>
      )}
      {identity !== "survey-categories" &&
        identity !== "theme-categories" &&
        identity !== "question-categories" &&
        identity !== "survey-list-manage" &&
        identity !== "survey-list" &&
        identity !== "survey-homelist" &&
        identity !== "event-list" &&
        identity !== "event-categories" &&
        identity !== "my-insights" &&
        identity !== "my-cases" &&
        identity !== "lob-list" &&
        identity !== "email-template-list" &&
        identity !== "coaches-list" &&
        identity !== "site-list" &&
        identity !== "event-list-coach" && (
          <OtherInfo className="d-flex align-items-center my-0">
            <b>Haven't answered:</b>
            <DownloadLink
              linkName={detail.remaining >= 0 ? detail.remaining : 0}
              object={item}
              fn={handleDownload}
            />
          </OtherInfo>
        )}
      {detail.countryName && identity === "lob-list" && (
        <OtherInfo>
          <b>{detail.countryName}</b>
        </OtherInfo>
      )}
      {detail.countryName && identity === "detail-report-list" && (
        <OtherInfo>
          <b>Country:</b> <span>{detail.countryName}</span>
        </OtherInfo>
      )}
      {(detail.cityName && identity !== "detail-report-list") && (
        <OtherInfo>
          <b>City:</b> <span>{detail.cityName}</span>
        </OtherInfo>
      )}
      {detail.agentsAssigned && (
        <OtherInfo>
          <b>Agents assigned:</b> <span>{detail.agentsAssigned}</span>
        </OtherInfo>
      )}
      {detail.type && (
        <OtherInfo>
          <b>Type:</b> <span>{detail.type}</span>
        </OtherInfo>
      )}
      {detail.categoryName && (
        <OtherInfo>
          <b>Category:</b>{" "}
          <Tooltip title={detail.categoryName}>
            <span>{detail.categoryName}</span>
          </Tooltip>
        </OtherInfo>
      )}
      {detail.registrationDate && (
        <OtherInfo>
          <b>Registrated on:</b> <span>{detail.registrationDate}</span>
        </OtherInfo>
      )}
      {detail.activationDate && (
        <OtherInfo>
          <b style={{ fontWeight: "600" }}>Activated on:</b>{" "}
          {detail.activationDate !== "Invalid date" ? (
            <span>{detail.activationDate}</span>
          ) : (
            <span>-</span>
          )}
        </OtherInfo>
      )}
      {identity === "survey-homelist" && (

        <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>

          <Tooltip title="Go To Survey">
            <Start>
              <StartButton onClick={() => {
                // console.log("Hell0 ->>>>>>> ",detail, encriptParametersSurvey);
                encriptParametersSurvey(
                  detail.id,
                  true,
                  false,
                  item?.isAnonymous
                );
              }}
              >
                Start
              </StartButton>
            </Start>
          </Tooltip>
          {/* <Start>
          <StartButton>
            Start
          </StartButton>
       
        </Start> */}
        </div>)}

      {detail.createDate && (
        <OtherInfo>
          <b>Created on:</b> <span>{detail.createDate}</span>
        </OtherInfo>
      )}
      {detail.codeColor && (
        <OtherInfo className="d-flex justify-content-between align-items-center">
          <div className="d-flex">
            <b>Assigned color:</b>&nbsp;
            <BoxColor colorBackground={detail.codeColor}></BoxColor>
          </div>
          <FormControlLabel
            className="my-2 mx-1"
            style={{ fontSize: "11px", color: themeConfig.neutral.gray[1300] }}
            control={<>{handleGreenSwitch(item)}</>}
          />
        </OtherInfo>
      )}
      {detail.eventDate && (
        <OtherInfo>
          <b>Event Date:</b> <span>{detail.eventDate}</span>
        </OtherInfo>
      )}
      {detail.startTime && (
        <OtherInfo>
          <b>Event Time:</b> <span>{detail.startTime}</span>
        </OtherInfo>
      )}
      {detail.theme && (
        <OtherInfo>
          <b>Theme :</b> <span>{detail.theme}</span>
        </OtherInfo>
      )}

      {!isAgent &&
        identity !== "survey-homelist" &&
        identity !== "my-insights" &&
        identity !== "my-cases" &&
        identity !== "event-categories" && (
          <>
            <ContainButtons
              displayProperty={
                identity === "survey-list-manage" ||
                identity === "event-list" ||
                identity === "event-list-coach"
              }
              displayPropertyInfoIcon={detail.itemState === 6}
              displayPropertyUnderApproval={isApprovalsRequested}
            >
              {item.integrationTpclient &&
                detail.itemState &&
                (detail.itemState === 5 || detail.itemState === 1) && (
                  <ButtonLinkActive
                    onClick={() => setOpenActiveSurveyModal(item)}
                  >
                    Activate
                  </ButtonLinkActive>
                )}
              {detail.itemState &&
                detail.itemState === 1 &&
                !item.integrationTpclient &&
                identity !== "detail-report-list" && (
                  <ButtonLinkActive
                    onClick={() => setOpenActiveSurveyModal(item)}
                  >
                    Activate
                  </ButtonLinkActive>
                )}
              {identity !== "detail-report-list" &&
                detail.itemState === 6 &&
                detail.itemState &&
                isApprovalsRequested && (
                  <ButtonLinkActive onClick={() => handleReview(item)}>
                    Review
                  </ButtonLinkActive>
                )}
              {identity !== "private-guests" &&
                identity !== "public-guests" &&
                identity !== "detail-report-list" &&
                identity !== "event-list" &&
                identity !== "event-list-coach" &&
                detail.itemState !== 1 &&
                detail.itemState !== 6 && (
                  <FormControlLabel
                    className="my-2"
                    style={{
                      fontSize: "11px",
                      color: themeConfig.neutral.gray[1300],
                      marginLeft: "1rem",
                    }}
                    control={<>{handleGreenSwitch(item)}</>}
                  />
                )}
              {(identity === "survey-categories" ||
                identity === "question-categories" ||
                identity === "theme-categories") && (
                  <MenuManageCategories
                    idManageCategories={detail.id}
                    item={item}
                    anchorSelected={anchorSelected}
                    anchorEl={anchorEl}
                    setAnchorEl={setAnchorEl}
                    setAnchorSelected={setAnchorSelected}
                    setOpenDeleteModal={setOpenDeleteModal}
                    setupdateData={setupdateData}
                    triggerValue={triggerValue}
                    setFormTrigger={setFormTrigger}
                    itemState={detail.itemState}
                  />
                )}
              {(identity === "survey-categories" ||
                identity === "question-categories" ||
                identity === "theme-categories") && (
                  <Tooltip title="Actions">
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      className={classes.active}
                      onClick={(e) => handleClickActions(e, item)}
                    >
                      <MenuActionsIcon />
                    </IconButton>
                  </Tooltip>
                )}

              {(identity === "event-list" ||
                identity === "event-list-coach") && (
                  <div style={{ display: "flex" }}>
                    <ClickAwayListener
                      onClickAway={() => setOpenDescription(false)}
                    >
                      <HtmlTooltip
                        placement="left"
                        open={openDescription}
                        title={
                          <>
                            {statistics.loading ? (
                              <p
                                style={{
                                  padding: "1em",
                                  margin: "0",
                                  listStyleType: "circle",
                                  lineHeight: "1.3",
                                  fontSize: "13px",
                                }}
                              >
                                {" "}
                                Loading...{" "}
                              </p>
                            ) : (
                              <div
                                style={{
                                  margin: "0",
                                  listStyleType: "circle",
                                  lineHeight: "1.3",
                                  fontSize: "13px",
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: detail.description,
                                }}
                              />
                            )}
                          </>
                        }
                        arrow
                      >
                        <IconButton size="small">
                          <InfoIcon
                            style={{
                              cursor: "pointer",
                              color: themeConfig.text.primary,
                            }}
                          />
                        </IconButton>
                      </HtmlTooltip>
                    </ClickAwayListener>
                    <FormControlLabel
                      className="my-2"
                      style={{
                        fontSize: "11px",
                        color: themeConfig.neutral.gray[1300],
                        marginLeft: 0,
                      }}
                      control={<>{handleGreenSwitch(item)}</>}
                    />
                  </div>
                )}

              {detail.description &&
                identity !== "lob-list" &&
                identity !== "event-list" &&
                identity !== "event-list-coach" && (
                  <ClickAwayListener
                    onClickAway={() => setOpenDescription(false)}
                  >
                    <HtmlTooltip
                      placement="left"
                      open={openDescription}
                      title={
                        <>
                          {statistics.loading ? (
                            <p
                              style={{
                                padding: "1em",
                                margin: "0",
                                listStyleType: "circle",
                                lineHeight: "1.3",
                                fontSize: "13px",
                              }}
                            >
                              {" "}
                              Loading...{" "}
                            </p>
                          ) : (
                            <ul
                              style={{
                                margin: "0",
                                listStyleType: "circle",
                                lineHeight: "1.3",
                                fontSize: "13px",
                              }}
                            >
                              <li
                                style={{ listStyleType: "disclosure-closed" }}
                              >
                                {labelDescription}
                              </li>
                              {identity !== "detail-report-list" ? (
                                <>
                                  {identity !== "email-template-list" && (
                                    <li
                                      style={{
                                        listStyleType: "disclosure-closed",
                                      }}
                                    >
                                      {"Assigned Users: " +
                                        statistics?.data?.usersAssigned}
                                    </li>
                                  )}
                                  {identity !== "email-template-list" && (
                                    <li
                                      style={{
                                        listStyleType: "disclosure-closed",
                                      }}
                                    >
                                      {"Pending users to answer: " +
                                        statistics?.data?.surveysRemaining}
                                    </li>
                                  )}
                                  {identity !== "email-template-list" && (
                                    <li
                                      style={{
                                        listStyleType: "disclosure-closed",
                                      }}
                                    >
                                      {"Have answered: " +
                                        statistics?.data?.surveysResponded}
                                    </li>
                                  )}
                                </>
                              ) : null}
                            </ul>
                          )}
                        </>
                      }
                      arrow
                    >
                      <IconButton
                        onClick={() => {
                          setOpenDescription(true);
                          if (
                            identity !== "detail-report-list" &&
                            identity !== "email-template-list"
                          ) {
                            statistics.getSurveyStatistics(detail.id);
                          }
                        }}
                      >
                        <InfoIcon
                          style={{
                            cursor: "pointer",
                            color: themeConfig.text.primary,
                          }}
                        />
                      </IconButton>
                    </HtmlTooltip>
                  </ClickAwayListener>
                )}
              {(identity === "event-list" ||
                identity === "event-list-coach" ||
                identity === "detail-report-list") && (
                  <ButtonViewPreview
                    className="btn"
                    onClick={() => handleSeeDetails(item)}
                  >
                    <ArrowForwardIcon style={{ fontSize: "1em" }} />
                  </ButtonViewPreview>
                )}
              {identity !== "survey-list-manage" &&
                identity !== "question-categories" &&
                identity !== "survey-categories" &&
                identity !== "theme-categories" &&
                identity !== "detail-report-list" &&
                identity !== "event-list" &&
                identity !== "event-list-coach" &&
                identity !== "event-categories" && (
                  <Tooltip title="Actions">
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      className={classes.active}
                      onClick={(e) => handleClickActions(e, item)}
                    >
                      <MenuActionsIcon />
                    </IconButton>
                  </Tooltip>
                )}
            </ContainButtons>
          </>
        )}
      {isAgent &&
        identity !== "my-insights" &&
        identity !== "my-cases" &&
        !isHistory && (
          <>
            {/* <Hr /> */}
            <ContainButtons className="mt-2">
              {detail.description && (
                <ClickAwayListener
                  onClickAway={() => setOpenDescription(false)}
                >
                  <Tooltip
                    open={openDescription}
                    title={labelDescription}
                    placement="left"
                    arrow
                  >
                    <IconButton onClick={() => setOpenDescription(true)}>
                      <InfoIcon
                        style={{
                          cursor: "pointer",
                          color: themeConfig.neutral.gray[1400],
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </ClickAwayListener>
              )}
              <Tooltip
                title={kindOfList === "Form" ? "Go To Form" : "Go To Survey"}
              >
                <ButtonViewPreview
                  className="btn"
                  disabled={
                    ((identity === "survey-list" && identity !== "survey-homelist") &&
                      item?.goToSurveyInfo?.goToSurvey) ||
                      ((identity === "survey-list" && identity !== "survey-homelist") &&
                        item?.goToSurveyInfo?.goToSurvey &&
                        detail.itemState === 2 &&
                        detail.itemState)
                      ? false
                      : true
                  }
                  onClick={() => {
                    const disablePreview =
                      (identity === "survey-list" &&
                        item?.goToSurveyInfo?.goToSurvey) ||
                        (identity === "survey-list" &&
                          item?.goToSurveyInfo?.goToSurvey &&
                          detail.itemState === 2 &&
                          detail.itemState)
                        ? false
                        : true;
                    if (!disablePreview) {
                      encriptParametersSurvey(
                        detail.id,
                        true,
                        false,
                        item?.isAnonymous
                      );
                    }
                  }}
                >
                  <ArrowForwardIcon style={{ fontSize: "1em" }} />
                </ButtonViewPreview>
              </Tooltip>
            </ContainButtons>
          </>
        )}
      {isAgent && isHistory && (
        <>
          <ContainButtons className="mt-2">
            {detail.description && (
              <ClickAwayListener onClickAway={() => setOpenDescription(false)}>
                <Tooltip
                  open={openDescription}
                  title={labelDescription}
                  placement="left"
                  arrow
                >
                  <IconButton onClick={() => setOpenDescription(true)}>
                    <InfoIcon
                      style={{
                        cursor: "pointer",
                        color: themeConfig.neutral.gray[1400],
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </ClickAwayListener>
            )}
            <Tooltip title={"Preview"}>
              <ButtonViewPreview
                className="btn"
                disabled={!item?.hasAnswerPreview}
                onClick={() => {
                  if (item?.hasAnswerPreview)
                    setOpenResumeAnswer(item?.idSurvey);
                }}
              >
                <ArrowForwardIcon style={{ fontSize: "1em" }} />
              </ButtonViewPreview>
            </Tooltip>
          </ContainButtons>
        </>
      )}

      {identity === "event-categories" && (
        <MenuManageCategories
          idManageCategories={detail.id}
          item={item}
          anchorSelected={anchorSelected}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          setAnchorSelected={setAnchorSelected}
          setOpenDeleteModal={setOpenDeleteModal}
          setupdateData={setupdateData}
          triggerValue={""}
        />
      )}

      {(identity === "event-list" ||
        identity === "event-list-coach" ||
        identity === "coaches-list" ||
        identity === "lob-list" ||
        identity === "site-list") && (
          <MenuManageEvents
            idManageEvents={detail.id}
            item={item}
            anchorSelected={anchorSelected}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            setAnchorSelected={setAnchorSelected}
            handleEditEvent={handleEditEvent}
            handleCloseActions={handleCloseActions}
            setOpenDeleteModal={setOpenDeleteModal}
            identity={identity}
            handleCreateSurveyFromTemplate={handleCreateSurveyFromTemplate}
            assignedUsers={detail.assignedUsers}
          />
        )}

      {identity === "email-template-list" && (
        <MenuManageEmailTemplate
          idManageEmails={detail.id}
          item={item}
          anchorSelected={anchorSelected}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          setAnchorSelected={setAnchorSelected}
          handleEditEmail={handleEditEmail}
          handleCloseActions={handleCloseActions}
          setOpenDeleteModal={setOpenDeleteModal}
        />
      )}

      {(identity === "private-guests" || identity === "public-guests") && (
        <MenuManageGuests
          idManageGuests={detail.id}
          item={item}
          anchorEl={anchorEl}
          anchorSelected={anchorSelected}
          handleCloseActions={handleCloseActions}
          setAnchorEl={setAnchorEl}
          setAnchorSelected={setAnchorSelected}
          setOpenDeleteModal={setOpenDeleteModal}
        />
      )}
      {detail.itemState === 1 && (
        <div style={{ border: `1px solid ${themeConfig.status.successDark}`, height: "5px" }}></div>
      )}
    </ContentListCard>
  );
};

export default ListCardViewControl;

ListCardViewControl.propTypes = {
  identity: PropTypes.string,
  isApprovalsRequested: PropTypes.bool,
  isAgent: PropTypes.bool,
  isHistory: PropTypes.bool,
  isRecurrent: PropTypes.bool,
  toggleChecked: PropTypes.func,
  handleClickActions: PropTypes.func,
  anchorSelected: PropTypes.number,
  anchorEl: PropTypes.number,
  handlePreview: PropTypes.func,
  handleCloseActions: PropTypes.func,
  handleEditSurvey: PropTypes.func,
  handleEditEvent: PropTypes.func,
  handleEditEmail: PropTypes.func,
  handleSeeDetails: PropTypes.func,
  handleDownload: PropTypes.func,
  handleGuests: PropTypes.func,
  setAnchorEl: PropTypes.func,
  setAnchorSelected: PropTypes.func,
  setOpenDeleteModal: PropTypes.func,
  setOpenCloneSurveyModal: PropTypes.func,
  setOnlyAssigned: PropTypes.func,
  encriptParametersSurvey: PropTypes.func,
  setOpenActiveSurveyModal: PropTypes.func,
  setupdateData: PropTypes.func,
  triggerValue: PropTypes.string,
  setFormTrigger: PropTypes.func,
  setOpenResumeAnswer: PropTypes.func,
  handleReview: PropTypes.func,
  style: PropTypes.object,
  handleCreateSurveyFromTemplate: PropTypes.func,
  statistics: PropTypes.object,
  handleRatingDownload: PropTypes.func,
  kindOfList: PropTypes.string,
  itsSurvey: PropTypes.bool,
};